import clsx from 'clsx';
import React, { memo } from 'react';
import { MuiChip } from '../material-ui';
import useStyles from './Chip.styles';

const ChipsFilter = ({
  theme,
  chipColor,
  isCategory = false,
  multiple,
  hoverable = true,
  className: overrideClassName,
  ...props
}: any) => {
  const classes = useStyles({});
  const chipClassName = clsx(
    classes.chip,
    isCategory && 'is-category',
    multiple && 'is-multiple',
    `${theme}-theme`,
    // Using text-color-* because MuiChip uses currentColor as background-color
    chipColor && `text-color-${chipColor}`,
    hoverable && 'is-hoverable',
    overrideClassName,
  );
  return <MuiChip {...props} className={chipClassName} />;
};

export default memo(ChipsFilter);
